import * as React from "react";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

// ✅ Custom Day (date styling)
const CustomDay = styled(PickersDay)(({ selected }) => ({
    width: 28,
    height: 28,
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "100%",
    color: "#121212",
    borderRadius: "50%",
    margin: 0,

    ...(selected && {
        border: "1px solid #1E3A8A",
        backgroundColor: "transparent",
    }),
}));

export default function CustomCalendar({
    selectedDate,
    setSelectedDate,
    handleDate,
}) {

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                sx={{
                    height: 208,
                    width: "239px !important",
                    p: 1,
                    border: "1px solid #F1F3F4",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 4px 0px #C2C5CC5E",
                    backgroundColor: "#fff",
                    fontFamily: "Inter",

                    "& .MuiCalendarPicker-root": {
                        width: "239px !important",
                    },

                    "& .MuiPickersCalendarHeader-root": {
                        mt: "0 !important",
                        paddingX: "12px",
                        marginBottom: "2px",
                        borderBottom: "1px solid #F1F3F4",
                    },

                    "& .MuiPickersCalendarHeader-label": {
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#121212",
                    },

                    "& .MuiSvgIcon-root": {
                        fontSize: "16px",
                        color: "#C4C4C4",
                    },

                    "& .MuiDayPicker-header": {
                        display: "flex",
                        justifyContent: "space-between",
                        width: 214,
                        margin: "0 auto",
                    },

                    "& .MuiDayPicker-weekDayLabel": {
                        width: 28,
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "8px",
                        fontWeight: 500,
                        color: "#828282",
                    },

                    "& .MuiDayPicker-weekContainer": {
                        display: "flex",
                        justifyContent: "space-between",
                        width: 214,
                        margin: "0 auto",
                    },

                    "& .MuiPickersDay-root": {
                        fontFamily: "Inter",
                    },
                }}
            >
                <CalendarPicker
                    date={selectedDate}
                    onChange={(newValue) => {
                        setSelectedDate(newValue);
                        handleDate(newValue);
                    }}
                    showDaysOutsideCurrentMonth
                    dayOfWeekFormatter={(day) =>
                    ({
                        Su: "Sun",
                        Mo: "Mon",
                        Tu: "Tue",
                        We: "Wed",
                        Th: "Thu",
                        Fr: "Fri",
                        Sa: "Sat",
                    }[day] ?? day)
                    }
                    renderDay={(day, _value, DayComponentProps) => (
                        <CustomDay
                            {...DayComponentProps}
                            day={day}
                            disableMargin
                            selected={day.isSame(selectedDate, "day")}
                        />
                    )}
                />
            </Box>
        </LocalizationProvider>
    );
}